<template>
  <div>
    <v-row>
      <v-col cols="12" class="">
        <form>
          <!-- Row 1 -->
          <div class="flex justify-start gap-12 mb-7">
            <div class="w-[440px]">
              <app-input-field
                id="1"
                :label="$t(getTranslatedStringKey('Address Line 1*'))"
                :placeholder="$t(getTranslatedStringKey('Address Line 1'))"
                v-model:modelValue="basicInfo.address_line_1"
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
              ></app-input-field>
            </div>
            <div class="w-[440px]">
              <app-input-field
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="2"
                :label="$t(getTranslatedStringKey('Address Line 2'))"
                :placeholder="$t(getTranslatedStringKey('Address Line 2'))"
                v-model:modelValue="basicInfo.address_line_2"
              ></app-input-field>
            </div>
          </div>
          <!-- Row 2 -->
          <div class="flex justify-start gap-12 mb-7">
            <div class="w-[440px]">
              <app-input-field
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="3"
                :label="$t(getTranslatedStringKey('City *'))"
                :placeholder="$t(getTranslatedStringKey('City'))"
                validation="lettersOnly"
                v-model:modelValue="basicInfo.city"
              ></app-input-field>
            </div>
            <div class="w-[440px]">
              <app-select-field
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="4"
                v-model="basicInfo.country"
                :label="$t(getTranslatedStringKey('Country *'))"
                :placeholder="$t('personal.selectCountry')"
                :options="countryOptions"
              ></app-select-field>
            </div>
          </div>
          <!-- Row 3 -->
          <div class="flex justify-start gap-12 mb-7">
            <div class="w-[440px]">
              <app-input-field
                type="text"
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="5"
                :label="$t(getTranslatedStringKey('Postal Code'))"
                :placeholder="$t(getTranslatedStringKey('Postal Code'))"
                validation="digitsAndLettersOnly"
                v-model:modelValue="basicInfo.postal_code"
              ></app-input-field>
            </div>
            <div class="w-[440px]">
              <app-input-field
                type="tel"
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="6"
                :label="$t(getTranslatedStringKey('Phone Number'))"
                :placeholder="$t(getTranslatedStringKey('Phone Number'))"
                validation="phoneOnly"
                v-model:modelValue="basicInfo.phone_number"
              ></app-input-field>
            </div>
          </div>
          <!-- Row 4 -->
          <div class="flex justify-start gap-12 mb-7">
            <div class="w-[440px]">
              <app-input-field
                type="email"
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="7"
                :label="$t(getTranslatedStringKey('Email *'))"
                :placeholder="$t(getTranslatedStringKey('Email'))"
                v-model:modelValue="basicInfo.email"
              ></app-input-field>
            </div>
            <div class="w-[440px]">
              <app-input-field
                type="tel"
                :disabled="
                  currentPath === '/edit-partner' &&
                  isEditPartner &&
                  !isEditButton
                "
                id="8"
                :label="$t('partners.faxNumber')"
                :placeholder="$t('partners.faxNumber')"
                validation="phoneOnly"
                v-model:modelValue="basicInfo.fax"
              ></app-input-field>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <div class="w-[920px]">
                <div
                  v-if="currentPath !== '/edit-partner'"
                  class="flex justify-end mb-7"
                >
                  <div class="flex gap-3">
                    <div>
                      <app-secondary-button
                        :buttonLabel="$t('personal.saveAndExit')"
                        @click-event="savePartnerInfo('exit')"
                        :disabled="disableSaveButton()"
                      >
                      </app-secondary-button>
                    </div>
                    <div>
                      <app-primary-button
                        @click-event="savePartnerInfo('continue')"
                        :buttonLabel="$t('personal.saveAndContinue')"
                        :disabled="disableSaveButton()"
                      >
                      </app-primary-button>
                    </div>
                  </div>
                </div>
                <div v-else class="flex justify-end gap-7">
                  <div v-show="isEditButton">
                    <app-secondary-button
                      :buttonLabel="$t('personal.cancel')"
                      @click="cancel"
                    ></app-secondary-button>
                  </div>
                  <app-primary-button
                    v-show="isEditButton"
                    :buttonLabel="$t('employment.saveChanges')"
                    @click-event="savePartnerInfo('edit')"
                    :disabled="disableSaveButton()"
                  >
                  </app-primary-button>
                </div>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-col>
    </v-row>

    <app-alert
      :title="$t(getTranslatedStringKey(alertTitle))"
      @close-alert="alertState = false"
      :state="alertState"
      :timeout="5000"
      :type="alertType"
    />
  </div>
  <div class="modal-board" v-if="showmodal && basicInfo.official_email === ''">
    <div class="flex justify-between">
      <h3 class="H400">We recommend that you provide an email</h3>
      <v-icon icon="custom:closeIcon" @click="showmodal = false" />
    </div>
    <p class="P300">
      Leaving the email blank means employees won’t receive any invitation
      email.
    </p>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import countries from "@/services/country_api";
import { getTransString } from "@/services/helpers";
import { countryCitizens } from "@/services/citizen";
import { validEmail } from "@/services/validation";
import Api from "@/services/api";
import { isEqual } from "lodash";
export default defineComponent({
  name: "Address",
  components: {},
  props: {
    errors: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      alertType: "success",
      alertState: false,
      alertTitle: "",
      isEdit: false,
      firstRunRef: true,
      loadUserKey: null,
      countryOptions: null,
      countryCitizensArray: [],
      originalFormData: {
        address_line_1: "",
        address_line_2: "",
        city: "",
        country: null,
        postal_code: "",
        email: "",
        phone_number: "",
        fax: "",
      },
      basicInfo: {
        address_line_1: "",
        address_line_2: "",
        city: "",
        country: null,
        postal_code: "",
        email: "",
        phone_number: "",
        fax: "",
      },
      allUserRoles: [],
      page: 1,
      roles: [],
      showmodal: true,
    };
  },
  computed: {
    isEditPartner() {
      return this.$store.getters["partnerModules/isEditPartner"];
    },
    canEditPersonalModule() {
      return this.$store.state.auth.canEditModuleSections;
    },
    isEditButton() {
      return (
        this.$store.getters["partnerModules/isEditButton"] &&
        this.canEditPersonalModule?.includes("Partner Address")
      );
    },
    isProjectPage() {
      return this.$store.getters["projectModules/isProjectPage"];
    },
    isPartnerData() {
      return this.$store.getters["partnerModules/isPartnerInfo"];
    },
    isPartnerId() {
      return this.$store.getters["partnerModules/isPartnerId"];
    },
    currentPath() {
      return this.$route.path;
    },
  },
  watch: {
    isPartnerData(value) {
      Object.keys(value).forEach((elt) => {
        if (Object.keys(this.basicInfo).includes(elt)) {
          this.basicInfo[elt] = value[elt];
          if (this.firstRunRef) {
            this.originalFormData[elt] = value[elt];
          }
        }
      });
      if (this.firstRunRef) {
        this.firstRunRef = false;
      }
    },
    basicInfo: {
      deep: true,
      handler(value) {
        this.$store.commit("partnerModules/SET_PARTNER_UPDATE", {
          Address: !isEqual(value, this.originalFormData),
        });
      },
    },
  },
  methods: {
    getCountryByName() {
      const countryArray = [];
      for (const country of countries) {
        countryArray.push(country.name);
      }
      return countryArray;
    },
    getTranslatedStringKey(field) {
      return getTransString(field);
    },
    handleNextClick() {
      this.$emit("next-clicked");
    },
    cancel() {
      this.$router.go(-1);
    },
    disableSaveButton() {
      const personalFormObj = { ...this.basicInfo };
      const excludes = ["email", "city", "country", "address_line_1"];
      const modifiedObject = Object.keys(personalFormObj).reduce(
        (prev, curr) => {
          if (!excludes.includes(curr)) {
            return prev;
          } else {
            prev[curr] = personalFormObj[curr];
            return prev;
          }
        },
        {}
      );
      return Object.values(modifiedObject).some((c) => c === "" || c === null);
    },

    savePartnerInfo(data) {
      if (this.basicInfo.email && !validEmail(this.basicInfo.email)) {
        this.alertType = "error";
        this.alertTitle = "Please enter a valid email address.";
        this.alertState = !this.alertState;
        return;
      }

      const payload = { ...this.basicInfo };

      if (this.isPartnerId) {
        payload.partner_id = this.isPartnerId;
      }

      Api()
        .post("/partners/add-new-partner/", payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.$store.commit(
              "partnerModules/SET_PERSONAl_DATA_TO_STATE",
              response.data.data
            );
            this.alertType = "success";
            this.alertTitle = response.data.detail;
            this.alertState = !this.alertState;

            this.$store.commit("partnerModules/SET_PARTNER_UPDATE", {
              Address: false,
            });

            setTimeout(() => {
              if (data === "exit") {
                this.$router.push({ name: "partners" });
              }
              if (data === "continue") {
                this.$store.commit(
                  "partnerModules/SET_CURRENT_TAB_TO_STATE",
                  2
                );
              }
            }, 1500);
          }
        })
        .catch((error) => {
          if (error) {
            this.alertType = "error";
            this.alertTitle = error.response.data.detail;
            this.alertState = !this.alertState;
          }
        });
    },

    getPartnerInfo() {
      Api()
        .get(`/partners/get-partner-info/${this.isPartnerId}/`)
        .then((response) => {
          if (response.data.status === "success") {
            const data = response.data.data;
            this.$store.commit(
              "partnerModules/SET_PERSONAl_DATA_TO_STATE",
              data
            );
          }
        });
    },
  },
  mounted() {
    // Loop through the countryCitizens object
    for (const country in countryCitizens) {
      if (Object.prototype.hasOwnProperty.call(countryCitizens, country)) {
        const citizen = countryCitizens[country];
        this.countryCitizensArray.push({ id: citizen, value: citizen });
      }
    }

    this.countryOptions = this.getCountryByName();
    // this.$store.commit("hrResources/SET_SHOW_EDIT_BUTTON_TO_STATE", false);
  },
  created() {
    this.$store.commit(
      "partnerModules/SET_EDIT_PARTNER_TO_STATE",
      this.isPartnerId !== null
    );
    this.isEdit = this.isEditPartner;
    this.$store.commit("partnerModules/SET_CURRENT_TAB_TO_STATE", 1);
    this.getPartnerInfo();
  },
});
</script>

<style scoped>
.select-field {
  width: 440px;
}

input[type="checkbox"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #d0d5dd;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s;
  position: relative;
}

input[type="checkbox"]:checked {
  background: #f4eae9;
}

input[type="checkbox"]:checked::before {
  content: "✔";
  color: #ae6a65;
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.modal-board {
  position: fixed;
  top: 90%;
  left: 85%;
  transform: translate(-50%, -50%);
  right: 0;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  width: 396px;
  height: 98px;
  background: #ffffff;
  border: 1px solid #f2f4f7;
  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, 0.08),
    0 4px 6px -2px rgba(16, 24, 40, 0.03);
  border-radius: 8px;
}
.disabled {
  /* cursor: not-allowed; */
  color: gray;
  opacity: 0.5;
}
</style>
